/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as SalesAccessIndexRouteImport } from './routes/sales-access.index'
import { Route as PartnersIndexRouteImport } from './routes/partners.index'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as ContingentsIndexRouteImport } from './routes/contingents.index'
import { Route as VenuesNewRouteImport } from './routes/venues.new'
import { Route as PartnersIdRouteImport } from './routes/partners.$id'
import { Route as EventsIdRouteImport } from './routes/events.$id'
import { Route as SalesAccessIdIndexRouteImport } from './routes/sales-access.$id.index'
import { Route as ContingentsContingentIdIndexRouteImport } from './routes/contingents.$contingentId.index'
import { Route as VenuesIdStudioRouteImport } from './routes/venues.$id.studio'
import { Route as VenuesIdSetupRouteImport } from './routes/venues.$id.setup'
import { Route as VenuesIdCanvasRouteImport } from './routes/venues.$id.canvas'
import { Route as SalesAccessEventEventIdRouteImport } from './routes/sales-access.event.$eventId'
import { Route as SalesAccessIdTabRouteImport } from './routes/sales-access.$id.$tab'
import { Route as ContingentsContingentIdTabRouteImport } from './routes/contingents.$contingentId.$tab'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesAccessIndexRoute = SalesAccessIndexRouteImport.update({
  id: '/sales-access/',
  path: '/sales-access/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersIndexRoute = PartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContingentsIndexRoute = ContingentsIndexRouteImport.update({
  id: '/contingents/',
  path: '/contingents/',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesNewRoute = VenuesNewRouteImport.update({
  id: '/venues/new',
  path: '/venues/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersIdRoute = PartnersIdRouteImport.update({
  id: '/partners/$id',
  path: '/partners/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIdRoute = EventsIdRouteImport.update({
  id: '/events/$id',
  path: '/events/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesAccessIdIndexRoute = SalesAccessIdIndexRouteImport.update({
  id: '/sales-access/$id/',
  path: '/sales-access/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContingentsContingentIdIndexRoute =
  ContingentsContingentIdIndexRouteImport.update({
    id: '/contingents/$contingentId/',
    path: '/contingents/$contingentId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const VenuesIdStudioRoute = VenuesIdStudioRouteImport.update({
  id: '/venues/$id/studio',
  path: '/venues/$id/studio',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIdSetupRoute = VenuesIdSetupRouteImport.update({
  id: '/venues/$id/setup',
  path: '/venues/$id/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const VenuesIdCanvasRoute = VenuesIdCanvasRouteImport.update({
  id: '/venues/$id/canvas',
  path: '/venues/$id/canvas',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesAccessEventEventIdRoute = SalesAccessEventEventIdRouteImport.update({
  id: '/sales-access/event/$eventId',
  path: '/sales-access/event/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesAccessIdTabRoute = SalesAccessIdTabRouteImport.update({
  id: '/sales-access/$id/$tab',
  path: '/sales-access/$id/$tab',
  getParentRoute: () => rootRouteImport,
} as any)
const ContingentsContingentIdTabRoute =
  ContingentsContingentIdTabRouteImport.update({
    id: '/contingents/$contingentId/$tab',
    path: '/contingents/$contingentId/$tab',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/events/$id': typeof EventsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/venues/new': typeof VenuesNewRoute
  '/contingents/': typeof ContingentsIndexRoute
  '/events/': typeof EventsIndexRoute
  '/partners/': typeof PartnersIndexRoute
  '/sales-access/': typeof SalesAccessIndexRoute
  '/contingents/$contingentId/$tab': typeof ContingentsContingentIdTabRoute
  '/sales-access/$id/$tab': typeof SalesAccessIdTabRoute
  '/sales-access/event/$eventId': typeof SalesAccessEventEventIdRoute
  '/venues/$id/canvas': typeof VenuesIdCanvasRoute
  '/venues/$id/setup': typeof VenuesIdSetupRoute
  '/venues/$id/studio': typeof VenuesIdStudioRoute
  '/contingents/$contingentId/': typeof ContingentsContingentIdIndexRoute
  '/sales-access/$id/': typeof SalesAccessIdIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/events/$id': typeof EventsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/venues/new': typeof VenuesNewRoute
  '/contingents': typeof ContingentsIndexRoute
  '/events': typeof EventsIndexRoute
  '/partners': typeof PartnersIndexRoute
  '/sales-access': typeof SalesAccessIndexRoute
  '/contingents/$contingentId/$tab': typeof ContingentsContingentIdTabRoute
  '/sales-access/$id/$tab': typeof SalesAccessIdTabRoute
  '/sales-access/event/$eventId': typeof SalesAccessEventEventIdRoute
  '/venues/$id/canvas': typeof VenuesIdCanvasRoute
  '/venues/$id/setup': typeof VenuesIdSetupRoute
  '/venues/$id/studio': typeof VenuesIdStudioRoute
  '/contingents/$contingentId': typeof ContingentsContingentIdIndexRoute
  '/sales-access/$id': typeof SalesAccessIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/events/$id': typeof EventsIdRoute
  '/partners/$id': typeof PartnersIdRoute
  '/venues/new': typeof VenuesNewRoute
  '/contingents/': typeof ContingentsIndexRoute
  '/events/': typeof EventsIndexRoute
  '/partners/': typeof PartnersIndexRoute
  '/sales-access/': typeof SalesAccessIndexRoute
  '/contingents/$contingentId/$tab': typeof ContingentsContingentIdTabRoute
  '/sales-access/$id/$tab': typeof SalesAccessIdTabRoute
  '/sales-access/event/$eventId': typeof SalesAccessEventEventIdRoute
  '/venues/$id/canvas': typeof VenuesIdCanvasRoute
  '/venues/$id/setup': typeof VenuesIdSetupRoute
  '/venues/$id/studio': typeof VenuesIdStudioRoute
  '/contingents/$contingentId/': typeof ContingentsContingentIdIndexRoute
  '/sales-access/$id/': typeof SalesAccessIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/events/$id'
    | '/partners/$id'
    | '/venues/new'
    | '/contingents/'
    | '/events/'
    | '/partners/'
    | '/sales-access/'
    | '/contingents/$contingentId/$tab'
    | '/sales-access/$id/$tab'
    | '/sales-access/event/$eventId'
    | '/venues/$id/canvas'
    | '/venues/$id/setup'
    | '/venues/$id/studio'
    | '/contingents/$contingentId/'
    | '/sales-access/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/events/$id'
    | '/partners/$id'
    | '/venues/new'
    | '/contingents'
    | '/events'
    | '/partners'
    | '/sales-access'
    | '/contingents/$contingentId/$tab'
    | '/sales-access/$id/$tab'
    | '/sales-access/event/$eventId'
    | '/venues/$id/canvas'
    | '/venues/$id/setup'
    | '/venues/$id/studio'
    | '/contingents/$contingentId'
    | '/sales-access/$id'
  id:
    | '__root__'
    | '/$'
    | '/events/$id'
    | '/partners/$id'
    | '/venues/new'
    | '/contingents/'
    | '/events/'
    | '/partners/'
    | '/sales-access/'
    | '/contingents/$contingentId/$tab'
    | '/sales-access/$id/$tab'
    | '/sales-access/event/$eventId'
    | '/venues/$id/canvas'
    | '/venues/$id/setup'
    | '/venues/$id/studio'
    | '/contingents/$contingentId/'
    | '/sales-access/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  EventsIdRoute: typeof EventsIdRoute
  PartnersIdRoute: typeof PartnersIdRoute
  VenuesNewRoute: typeof VenuesNewRoute
  ContingentsIndexRoute: typeof ContingentsIndexRoute
  EventsIndexRoute: typeof EventsIndexRoute
  PartnersIndexRoute: typeof PartnersIndexRoute
  SalesAccessIndexRoute: typeof SalesAccessIndexRoute
  ContingentsContingentIdTabRoute: typeof ContingentsContingentIdTabRoute
  SalesAccessIdTabRoute: typeof SalesAccessIdTabRoute
  SalesAccessEventEventIdRoute: typeof SalesAccessEventEventIdRoute
  VenuesIdCanvasRoute: typeof VenuesIdCanvasRoute
  VenuesIdSetupRoute: typeof VenuesIdSetupRoute
  VenuesIdStudioRoute: typeof VenuesIdStudioRoute
  ContingentsContingentIdIndexRoute: typeof ContingentsContingentIdIndexRoute
  SalesAccessIdIndexRoute: typeof SalesAccessIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-access/': {
      id: '/sales-access/'
      path: '/sales-access'
      fullPath: '/sales-access/'
      preLoaderRoute: typeof SalesAccessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/': {
      id: '/partners/'
      path: '/partners'
      fullPath: '/partners/'
      preLoaderRoute: typeof PartnersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contingents/': {
      id: '/contingents/'
      path: '/contingents'
      fullPath: '/contingents/'
      preLoaderRoute: typeof ContingentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/new': {
      id: '/venues/new'
      path: '/venues/new'
      fullPath: '/venues/new'
      preLoaderRoute: typeof VenuesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/$id': {
      id: '/partners/$id'
      path: '/partners/$id'
      fullPath: '/partners/$id'
      preLoaderRoute: typeof PartnersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$id': {
      id: '/events/$id'
      path: '/events/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof EventsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-access/$id/': {
      id: '/sales-access/$id/'
      path: '/sales-access/$id'
      fullPath: '/sales-access/$id/'
      preLoaderRoute: typeof SalesAccessIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contingents/$contingentId/': {
      id: '/contingents/$contingentId/'
      path: '/contingents/$contingentId'
      fullPath: '/contingents/$contingentId/'
      preLoaderRoute: typeof ContingentsContingentIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$id/studio': {
      id: '/venues/$id/studio'
      path: '/venues/$id/studio'
      fullPath: '/venues/$id/studio'
      preLoaderRoute: typeof VenuesIdStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$id/setup': {
      id: '/venues/$id/setup'
      path: '/venues/$id/setup'
      fullPath: '/venues/$id/setup'
      preLoaderRoute: typeof VenuesIdSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/venues/$id/canvas': {
      id: '/venues/$id/canvas'
      path: '/venues/$id/canvas'
      fullPath: '/venues/$id/canvas'
      preLoaderRoute: typeof VenuesIdCanvasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-access/event/$eventId': {
      id: '/sales-access/event/$eventId'
      path: '/sales-access/event/$eventId'
      fullPath: '/sales-access/event/$eventId'
      preLoaderRoute: typeof SalesAccessEventEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales-access/$id/$tab': {
      id: '/sales-access/$id/$tab'
      path: '/sales-access/$id/$tab'
      fullPath: '/sales-access/$id/$tab'
      preLoaderRoute: typeof SalesAccessIdTabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contingents/$contingentId/$tab': {
      id: '/contingents/$contingentId/$tab'
      path: '/contingents/$contingentId/$tab'
      fullPath: '/contingents/$contingentId/$tab'
      preLoaderRoute: typeof ContingentsContingentIdTabRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  EventsIdRoute: EventsIdRoute,
  PartnersIdRoute: PartnersIdRoute,
  VenuesNewRoute: VenuesNewRoute,
  ContingentsIndexRoute: ContingentsIndexRoute,
  EventsIndexRoute: EventsIndexRoute,
  PartnersIndexRoute: PartnersIndexRoute,
  SalesAccessIndexRoute: SalesAccessIndexRoute,
  ContingentsContingentIdTabRoute: ContingentsContingentIdTabRoute,
  SalesAccessIdTabRoute: SalesAccessIdTabRoute,
  SalesAccessEventEventIdRoute: SalesAccessEventEventIdRoute,
  VenuesIdCanvasRoute: VenuesIdCanvasRoute,
  VenuesIdSetupRoute: VenuesIdSetupRoute,
  VenuesIdStudioRoute: VenuesIdStudioRoute,
  ContingentsContingentIdIndexRoute: ContingentsContingentIdIndexRoute,
  SalesAccessIdIndexRoute: SalesAccessIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
